import { useTheme } from '@material-ui/core';
import TableBody from '@material-ui/core/TableBody';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo, useState } from 'react';
import EmptyBody from './EmptyBody';
import Row from './Row';
import { getHoverStyle } from './Row.styles';
import { TableRowActionExact } from '../../models/tableRowAction';

const Body = ({ rows, prepareRow, onRowClick, rowActions, selectedRowEntityId }) => {
  const theme = useTheme();

  const hoverEnabled = useMemo(() => !!onRowClick || rowActions.length > 0, [onRowClick, rowActions]);

  const [clickedRowId, setClickedRowId] = useState();

  const getRowStyle = useCallback(
    (row) => ((selectedRowEntityId && row.original && selectedRowEntityId === row.original.id) || clickedRowId === row.id ? getHoverStyle(theme) : undefined),
    [clickedRowId, selectedRowEntityId, theme]
  );

  const handleClick = useCallback(
    (rowValue, rowId) => {
      if (onRowClick) {
        onRowClick(rowValue);
        setClickedRowId(rowId);
      }
    },
    [onRowClick, setClickedRowId]
  );

  if (rows.length === 0) return <EmptyBody />;

  return (
    <TableBody>
      {rows.map((row) => {
        prepareRow(row);
        const { key, role } = row.getRowProps();
        return <Row key={key} role={role} row={row} onRowClick={handleClick} rowActions={rowActions} hoverEnabled={hoverEnabled} style={getRowStyle(row)} />;
      })}
    </TableBody>
  );
};

Body.propTypes = {
  onRowClick: PropTypes.func,
  prepareRow: PropTypes.func.isRequired,
  rowActions: PropTypes.arrayOf(TableRowActionExact),
  rows: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  selectedRowEntityId: PropTypes.number,
};

Body.defaultProps = {
  onRowClick: undefined,
  rowActions: [],
  selectedRowEntityId: undefined,
};

export default Body;
